import Seo, { breadcrumbs } from "../components/Seo";
import LeadForm from "../components/LeadForm";
import { SectionHeader } from "../components/UI";
import PushAlertSignup from "../components/PushAlertSignup";

export default function VehicleAlerts() {
  return (
    <main id="main-content">
      <Seo
        title="Vehicle Alerts in Central Ohio | Scott Sells Chevys"
        description="Tell Scott what vehicle you want and get notified when a matching new or used vehicle arrives."
        canonicalPath="/vehicle-alerts"
        jsonLd={[breadcrumbs([{ name: "Home", path: "/" }, { name: "Vehicle Alerts", path: "/vehicle-alerts" }])]}
      />
      <section className="ssc-hero">
        <div className="ssc-container py-10 md:py-16">
          <h1 className="ssc-display text-3xl md:text-5xl font-extrabold">Want Me to Watch for Something?</h1>
          <p className="mt-3 text-[var(--ssc-silver)] max-w-2xl">Tell me what to look for and I'll let you know when something matches.</p>
        </div>
      </section>
      <section className="ssc-section">
        <div className="ssc-container max-w-3xl">
          <SectionHeader
            title="Get push alerts the moment a match lands"
            subtitle="Skip the inbox. Works on iPhone, Android, and desktop — best after you install the app."
          />
          <PushAlertSignup />
        </div>
      </section>

      <section className="ssc-section">
        <div className="ssc-container max-w-3xl">
          <SectionHeader title="Prefer text or email? Let Scott know what to watch for." />
          <ul className="ssc-card text-[var(--ssc-ink-2)] space-y-1 list-disc pl-5 mb-6">
            <li>Text me when a Colorado Trail Boss arrives.</li>
            <li>Tell me when an AWD SUV under $25k comes in.</li>
            <li>Let me know when an Equinox EV deal is available.</li>
          </ul>
          <LeadForm
            leadType="vehicle_alert"
            leadSource="Vehicle Alerts Page"
            testIdPrefix="alert-lead"
            fields={[
              { name: "name", label: "Name", required: true, autoComplete: "name" },
              { name: "phone", label: "Phone", inputMode: "tel", autoComplete: "tel" },
              { name: "email", label: "Email", type: "email", autoComplete: "email" },
              { name: "vehicle_wanted", label: "Vehicle Wanted" },
              { name: "new_or_used", label: "New or Used", type: "select", options: ["New", "Used", "Either"] },
              { name: "budget", label: "Budget" },
              { name: "mileage_limit", label: "Mileage Limit" },
              { name: "must_haves", label: "Must-Have Features", full: true },
              { name: "color_preferences", label: "Color Preferences" },
              { name: "timeline", label: "Timeline", type: "select", options: ["Right away", "1–4 weeks", "1–3 months", "Whenever it shows up"] },
              { name: "trade_in", label: "Trade-In?", type: "select", options: ["Yes", "No"] },
              { name: "preferred_contact", label: "Preferred Contact", type: "select", options: ["Text", "Call", "Email"] },
            ]}
            submitLabel="Create My Vehicle Alert"
          />
        </div>
      </section>
    </main>
  );
}
